<template>
    <div class="progress">
        <div class="progress-bar" :class="classes" role="progressbar" :style="{ width: calculatedPercent + '%' }">{{ calculatedLabel }}</div>
    </div>
</template>

<script>
    export default {
        name: 'Progress',
        props: {
            color: String,
            percent: Number,
            total: Number,
            count: Number,
            label: [ String, Number ]
        },
        computed: {
            calculatedPercent: function() {
                // Already calculated
                if (this.percentDefined)
                    return this.percent
                // Calculate
                return Math.round((this.count / this.total) * 100)
            },
            calculatedLabel: function() {
                return this.label ? this.label : (this.percentDefined ? this.percent + '%' : (this.count + '/' + this.total))
            },
            classes: function() {
                if (this.color) {
                    return 'bg-' + this.color
                }
                else {
                    return [
                        { 'bg-danger': this.calculatedPercent >= 80 },
                        { 'bg-warning': this.calculatedPercent < 80 && this.calculatedPercent >= 60 },
                        { 'bg-success': this.calculatedPercent < 60 }
                    ]
                }
            },
            percentDefined: function() {
                return typeof this.percent !== 'undefined'
            }
        }
    }
</script>